import { cn } from "helpers/classNames";
import React, { FC } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

interface Props {
  children: React.ReactNode;
  isFirstColumn?: boolean;
  isLastColumn?: boolean;
  hideOnMobile?: boolean;
  hideOnTablet?: boolean;
  isLink?: boolean;
  sortDirection?: "ASC" | "DESC";
  onSortClick?: (columnName: string) => void;
  columnName?: string;
  currentSortColumn?: string;
}

export const TH: FC<
  Props &
    React.DetailedHTMLProps<
      React.TableHTMLAttributes<HTMLTableCellElement>,
      HTMLTableCellElement
    >
> = ({
  children,
  isFirstColumn = false,
  isLastColumn = false,
  hideOnMobile = false,
  hideOnTablet = false,
  isLink = false,
  className,
  sortDirection,
  onSortClick,
  columnName,
  currentSortColumn,
  ...rest
}) =>
  isLink ? (
    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
      {children}
    </th>
  ) : (
    <th
      scope="col"
      className={cn(
        `${
          hideOnTablet
            ? "hidden lg:table-cell"
            : hideOnMobile
              ? "hidden sm:table-cell"
              : ""
        } ${
          isFirstColumn
            ? "py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-600 sm:pl-6"
            : isLastColumn
              ? "relative py-3 pl-4 pr-4 text-left text-sm sm:pr-6"
              : "px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-600"
        }`,
        className,
      )}
      {...rest}
    >
      {onSortClick ? (
        <button
          type="button"
          onClick={() => onSortClick(columnName!)}
          className="group inline-flex items-center"
        >
          {children}
          <span className="ml-1 flex-none rounded text-gray-400 group-hover:visible">
            {currentSortColumn === columnName && sortDirection === "ASC" ? (
              <ChevronUpIcon
                aria-hidden="true"
                className={cn(
                  "size-5 rounded-lg",
                  currentSortColumn === columnName
                    ? "bg-blue-300 text-blue-900"
                    : "group-hover:bg-blue-200",
                )}
              />
            ) : (
              <ChevronDownIcon
                aria-hidden="true"
                className={cn(
                  "size-5 rounded-lg",
                  currentSortColumn === columnName
                    ? "bg-blue-300 text-blue-900"
                    : "group-hover:bg-blue-200",
                )}
              />
            )}
          </span>
        </button>
      ) : (
        children
      )}
    </th>
  );

// type SortButtonProps = {
//   sortDirection?: "ASC" | "DESC";
//   isSortActive?: boolean;
// };
// const SortButton = ({ sortDirection, isSortActive }: SortButtonProps) => {
//   if (!sortDirection) {
//     return null;
//   }
// };
